__webpack_require__.p = "/toknes-primary-color-update/referrals-hub/";